<template lang="pug">
div
  PageTitle(
    :pagetitle = "pagetitle",
    :tip = "tip")
    slot(name="accountSelect")
  slot(name="tabview")
  div(:class="{'zone crowd-zone': hasCrowd}")
    CompTimeSpan(
      :type="timeType",
      :compared="compared",
      :compareDisabled="compareDisabled",
      @rangeChange="getWebData",
      @compRangeChange="compRangeChange")
    slot(name="crowd")
  slot(name="crowd-content")

  .zone
    TableTitle(icon="fa fa-signal" title="趋势图")
      IndiceCompare(
        :compared="compared",
        :indicesMenu="indicesMenu",
        @indiceChange="indiceChange",
        :indice="customIndice",
        :compIndice="twoIndice",
        :twoIndiceShow="twoIndiceShow")

    LineChart(
      :yAxis="yAxis",
      :legend="legend",
      :xAxis="chartXAxis",
      :series="chartSeries")

  .zone
    TableTitle(icon="fa fa-list", :title="tableTabTitle")
      slot(name="tableTitleTip")
    div
      slot(name='nav-tabs')
    complex-table(
      :classname="tableClassname",
      :columns="columns",
      :list="tableDataList",
      :sum="sum",
      :sumchecked="sumchecked",
      :checkbox="hasCheckBox",
      :checkbox_length="checkboxLength",
      :sortKey="order",
      :sortOrder="isasc",
      :pagetitle = "pagetitle")
      template(slot="custom")
        slot(name="custom")

    v-pagination(
      :total="total",
      :pn="pg",
      :ps="ps",
      v-if="total > ps",
      @updatepage="updatePage")

</template>
<script>
/* global _ */
import { mapState, mapActions, mapGetters } from 'vuex'
import Store from '../../store/store.js'
import Table from '../../component/complex-table.vue'
import Mixin from '../mixin.js'

export default {
  store: Store,
  mixins: [Mixin],
  props: {
    tableClassname: String,
    timeType: {
      type: String,
      default: 'normal'
    },
    hasCrowd: Boolean,
    compareDisabled: Boolean,
    total: Number,
    pg: Number,
    ps: Number,
    pagetitle: String,
    tip: String,
    currentTab: String,
    tablist: Array,
    sumchecked: Boolean,
    tableDataList: {
      type: Array,
      default: () => []
    },
    customColumns: {
      type: Array,
      default: () => []
    },
    defaultColumns: {
      type: Array,
      default: () => [
        {
          title: '分析维度',
          fixed: true,
          children: [
            {
              title: '',
              key: 'name',
              width: 300,
              render: (index, value, item, type) => {
                if (value && !_.isNull(value)) {
                  return `<span title="${value}">${value}</span>`
                }
                return value
              }
            }
          ]
        }
      ]
    },
    hasCheckBox: {
      type: Boolean,
      default: false
    },
    checkboxLength: {
      type: Number,
      default: 3
    },
    order: {
      type: String,
      default: 'date'
    },
    isasc: {
      type: Number,
      default: 0
    },
    sum: {
      type: [String, Object],
      default: () => {}
    },
    legend: {
      type: Array,
      default: () => []
    },
    yAxis: {
      type: Array,
      default: () => []
    },
    chartXAxis: {
      type: Array,
      default: () => []
    },
    chartSeries: {
      type: Array,
      default: () => []
    },
    customIndice: {
      type: String,
      default: 'adpv'
    },
    twoIndice: {
      type: String,
      default: ''
    },
    twoIndiceShow: {
      type: Boolean,
      default: true
    }
  },
  components: {
    'complex-table': Table
  },
  computed: {
    ...mapState('web', {
      tableIndices: state => state.tableIndices,
      compared: state => state.compared,
      compareStart: state => state.compareStart,
      compareEnd: state => state.compareEnd
    }),
    ...mapGetters('web', [
      'indicesMenu',
      'start',
      'end'
    ]),
    start () {
      return this.$store.state.start.replace(/-/g, '/')
    },
    end () {
      return this.$store.state.end.replace(/-/g, '/')
    },
    tableTabTitle () {
      return `${_.find(this.tablist, {id: this.currentTab}).name}报表`
    },
    columns () {
      if (_.isEmpty(this.customColumns)) {
        const columns = this.defaultColumns
        const customColumns = this.getCustomColumns({hasSpread: false})
        columns[0].children[0].title = _.find(this.tablist, {id: this.currentTab}).name
        const newColumns = this.getRecombineColumns(customColumns, this.tableIndices)
        return _.concat(columns, newColumns)
      }
      return this.customColumns
    }
  },
  watch: {
  },
  methods: {
    ...mapActions('web', {
      setCompared: 'SET_COMPARED'
    }),
    sorter (key, order) {
      this.$emit('tablesorter', {key, order})
    },
    // 切换图标维度
    indiceChange (obj) {
      this.$emit('indiceChange', obj)
    },
    // 对比时间更新
    compRangeChange (comparedObj) {
      this.setCompared(comparedObj)
      this.chartResList = []
      this.$emit('tableUpdate')
    },
    // 重置compared并获取数据
    resetCompared () {
      this.setCompared({compared: false, compStart: '', compEnd: ''})
      this.chartResList = []
      if (this.hasCrowd) {
        this.$emit('timeRangeChange')
      } else {
        this.$emit('tableUpdate')
      }
    },
    getWebData () {
      // 获取table数据
      this.resetCompared()
    },
    updatePage (pn) {
      this.$emit('tableUpdate', pn)
    }
  }
  //  时间同步，不必移除
  /*
  destory () {
    this.setCompared({compared: false, compStart: '', compEnd: ''})
  }
  */
}
</script>
<style scoped>
.crowd-zone {
  border-top: 0;
  .time {
    margin-left: 15px;
  }
}
.crowd-content + .zone {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// template.vue?5e54fd52